import "./App.css";
import Footer from "./Components/Footer";
import Header from "./Components/Header";
import { LinkLocation } from "./Components/LinkLocation";
import GenericRoutes from "./Routes";
import WhatsappLogo from "./assets/whatsapp-logo.png";
import ChatbotWidget from "./Components/ChatbotWidget";

function App() {
  return (
    <div>
      <div className="min-h-screen flex flex-col">
        <Header />
        <div className="flex-grow">
          <GenericRoutes />
        </div>
        <Footer />
      </div>
      
      {/* Chatbot Widget - positioned at bottom right */}
      <ChatbotWidget />
      
      {/* WhatsApp Icon - positioned above chatbot or to the left */}
      <div className="fixed bottom-24 right-5 z-50">
        <LinkLocation
          to={
            "https://api.whatsapp.com/message/7WHRUPBYFWWNA1?text=Xenia%Technologies&autoload=1&app_absent=0"
          }
        >
          <img
            src={WhatsappLogo}
            alt="whatsapp_logo"
            className="w-12 h-12 cursor-pointer hover:scale-110 transition-transform duration-200"
          />
        </LinkLocation>
      </div>
    </div>
  );
}

export default App;